export enum WebStorageType {
	LocalStorage = 'localStorage',
	SessionStorage = 'sessionStorage',
}
